module.exports = __webpack_public_path__ + "img/nt108-00-81-1.asm.f7f0af06.jpg";